import { siteVersion } from '@/global/public-settings';

type USD = number;
type Percents = number;

export const constantMakerFee: Percents = 0.01;

const monthlyVolumeBottomBound: USD = 5000000;
const monthlyVolumeTopBound: USD = 20000000;

const takerFeesVolumes: { [bound: string]: Percents } = {
  low: 0.02,
  mid: 0.035,
  high: 0.045,
};

const minimumDeposit: USD = siteVersion.isAfrica ? 15 : 1;

const withdrawalFee: USD = 0;

const tradingStartingFrom: { [bound: string]: USD } = {
  btcUsdt: 69000,
};

export const getDepositsWithdrawalsData = () => {
  return {
    minimumDeposit,
    withdrawalFee,
  };
};

export const getMonthlyVolumeBounds = () => {
  return {
    top: monthlyVolumeTopBound,
    bottom: monthlyVolumeBottomBound,
  };
};

export const calculateTakerFee = (monthlyVolume: USD) => {
  if (monthlyVolume >= monthlyVolumeTopBound) {
    return takerFeesVolumes.low;
  }

  if (monthlyVolume >= monthlyVolumeBottomBound) {
    return takerFeesVolumes.mid;
  }

  return takerFeesVolumes.high;
};

export const getTakerFeeVolumes = () => takerFeesVolumes;

export const getTradingStartingFrom = () => tradingStartingFrom;
